

/**
 * Main JS file for Joelma
 */

jQuery(function($) {

    if(typeof changeConfig !== "undefined"){
        config = Object.assign(config, changeConfig);
    }

    var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
        h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
        monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "Sepember", "October", "November", "December"];

    var ghostAPI = new GhostContentAPI({
        url: config['content-api-url'],
        key: config['content-api-key'],
        version: 'v5'
    });

    // Featured Posts Slider

    if ($('.intro .swiper-slide').length == 1) {
        $('.intro .swiper-pagination').addClass('hidden');
    };

    setGalleryRation();

    var swiperIntro = new Swiper('.intro .swiper-container', {
        pagination: {
            el: '.intro .swiper-pagination',
            clickable: true,
        },
        simulateTouch: false,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
    });

    if ($('.intro').length) {
        $('.intro .swiper-pagination .swiper-pagination-bullet:nth-child('+ (swiperIntro.activeIndex+2) +')').addClass('next');
        swiperIntro.on('slideChange', function () {
            $('.intro .swiper-pagination .swiper-pagination-bullet').removeClass('next');
            if (swiperIntro.isEnd) {
                $('.intro .swiper-pagination .swiper-pagination-bullet:nth-child(1)').addClass('next');
            }else{
                $('.intro .swiper-pagination .swiper-pagination-bullet:nth-child('+ (swiperIntro.activeIndex+2) +')').addClass('next');
            };
        });
    };

    // Related Posts Slider

    var swiperRelatedPosts = new Swiper('.related-posts .swiper-container', {
        slidesPerView: 'auto',
        centeredSlides: true,
        roundLengths: true,
        navigation: {
            nextEl: '.related-posts .swiper-button-next',
            prevEl: '.related-posts .swiper-button-prev',
        },
        a11y: {
            firstSlideMessage: 'To jest pierwszy slajd',
            lastSlideMessage: 'To jest ostatni slajd',
            prevSlideMessage: 'Poprzedni slajd',
            nextSlideMessage: 'Następny slajd',
          },
    });

    $('.go').on('click', function(event) {
        event.preventDefault();
        $("html, body").animate({ scrollTop: $('#content').offset().top }, 600);
        return false;
    });

    $('.social-trigger, .bookmark, .search-trigger, .navigation-trigger, .trigger-share').on('click', function(event) {
        event.preventDefault();
    });    

    function closePopover(id){
        $(id).find('.close').on('click', function(event) {
            event.preventDefault();
            $(id).popover('hide');
        });
    }

    $('.navigation-trigger').on('shown.bs.popover', function () {
        var id = $('.navigation-trigger').attr('aria-describedby');
        if (w > 575) {
            if (!$('body').hasClass('ie')) {
                new SimpleBar($('#' + id)[0]);
            };
        }
        closePopover('#' + id);
    });

    // Initialize Highlight.js
    $('pre code').each(function(i, block) {
        hljs.highlightBlock(block);
    });

    var imgHeight = 0;
    $('.related-posts').imagesLoaded( function() {
        $('.related-posts img').each(function(index, el) {
            if (imgHeight >= $(this).height() || imgHeight == 0) {
                imgHeight = $(this).height();
            };
        });
        $('.related-posts .img-holder').each(function(index, el) {
            $(this).height(imgHeight);
        });
    });

    // Check if element is into view when scrolling
    function isScrolledIntoView(elem){
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();

        var elemTop = $(elem).offset().top;
        var elemBottom = elemTop + $(elem).height();

        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }

    // Execute on resize
    // $(window).on('resize', function(event) {
    //     w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    //     stickyShareButtons(w);
    // });

    if ($('.error-title').length) {
        $('body').addClass('error');
    };

    // Set the right proportion for images inside the gallery
    function setGalleryRation(){
        $('.kg-gallery-image img').each(function(index, el) {
            var container = $(this).closest('.kg-gallery-image');
            var width = $(this)[0].naturalWidth;
            var height = $(this)[0].naturalHeight;
            var ratio = width / height;
            container.attr('style', 'flex: ' + ratio + ' 1 0%');
        });
    }

    // Parse the URL parameter
    function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
    // Give the parameter a variable name
    var action = getParameterByName('action');
    var stripe = getParameterByName('stripe');

    if (action == 'subscribe') {
        $('body').addClass("subscribe-success");
    }
    if (action == 'signup') {
        window.location = '/signup/?action=checkout';
    }
    if (action == 'checkout') {
        $('body').addClass("signup-success");
    }
    if (action == 'signin') {
        $('body').addClass("signin-success");
    }
    if (stripe == 'success') {
        $('body').addClass("checkout-success");
    }
    $('.notification-close').click(function () {
        $(this).parent().addClass('closed');
        var uri = window.location.toString();
        if (uri.indexOf("?") > 0) {
            var clean_uri = uri.substring(0, uri.indexOf("?"));
            window.history.replaceState({}, document.title, clean_uri);
        }
    });

});

jQuery("#rt-contact-submit").on('click', function(event){
    event.preventDefault();
    grecaptcha.enterprise.ready(async () => {
    const token = await grecaptcha.enterprise.execute('6Ld_TTAqAAAAAM9Mpk6cGNQIYNT_N34IX_NaqL-v', {action: 'CONTACT'});

    var formValue = objectifyForm(jQuery("#rt-contact-form").serializeArray());
    var phoneRegEx = new RegExp("(?<!\\w)(\\(?(\\+|00)?48\\)?)?[ -]?\\d{3}[ -]?\\d{3}[ -]?\\d{3}(?!\\w)")

    jQuery("#rt-contact-form")[0].classList.add("rt-invalid-form")
    document.getElementById("rt-contact-form").reportValidity();
    document.getElementById("rt-contact-phone").classList.remove("invalid");

    let msg = "";
    let nameError = "";
    let phoneError = "";
    let emailError = "";
    let messageError = "";
    let termsError = "";
    
    if(!formValue["name"]) {
        nameError = "Imię jest wymagane.\n";
    }

    if (nameError != "") {
        msg += nameError;
        jQuery("#contact-invalid-name").show();
        jQuery("#contact-invalid-name").text(nameError);
    } else {
        jQuery("#contact-invalid-name").hide();
    }

    if(!formValue["phone"]) {
        phoneError = "Telefon jest wymagany.\n"
    } else if (!phoneRegEx.test(formValue["phone"])) {
        var letterRegExp = /[a-zA-Z]/g;
        if(letterRegExp.test(formValue["phone"])){
            phoneError = "Numer telefonu nie powinien zawierać liter\n"
        } else {
            phoneError = "Telefon jest niepoprawny. Przykładowy numer telefony to \"+48 123 456 789\" \n"
        }
    }

    if (phoneError != "") {
        msg += phoneError;
        document.getElementById("rt-contact-phone").classList.add("invalid");
        jQuery("#contact-invalid-phone").show();
        jQuery("#contact-invalid-phone").text(phoneError);
    } else {
        document.getElementById("rt-contact-phone").classList.remove("invalid");
        jQuery("#contact-invalid-phone").hide();
    }


    if(!formValue["email"]) {
        emailError = "Adres Email jest wymagany. "
    } else if(!validateEmail(formValue["email"])) {
        emailError = "Adres Email jest niepoprawny. Upewnij się, że jest w formacie \"nazwa@domena.pl\".\n";
    }

    if (emailError != "") {
        msg += emailError;
        document.getElementById("rt-contact-email").classList.add("invalid");
        jQuery("#contact-invalid-email").show();
        jQuery("#contact-invalid-email").text(emailError);
    } else {
        document.getElementById("rt-contact-email").classList.remove("invalid");
        jQuery("#contact-invalid-email").hide();
    }

    if(!formValue["message"]) {
        messageError = "Wiadomość jest wymagana.\n"
    }

    if (messageError != "") {
        msg += messageError;
        jQuery("#contact-invalid-message").show();
        jQuery("#contact-invalid-message").text(messageError);
    } else {
        jQuery("#contact-invalid-message").hide();
    }

    if(!formValue["accept-terms"]) {
        termsError = "Akceptacja regulaminu jest wymagana.\n"
    }

    if (termsError != "") {
        msg += termsError;
        jQuery("#contact-invalid-terms").show();
        jQuery("#contact-invalid-terms").text(termsError);
    } else {
        jQuery("#contact-invalid-terms").hide();
    }

    if (msg != "") {
        alert(msg);
        return false
    }
    
    jQuery("#rt-contact-submit")[0].disabled = true;
    var formData = {
        name: jQuery("#rt-contact-name").val(),
        phone: jQuery("#rt-contact-phone").val(),
        email: jQuery("#rt-contact-email").val(),
        message: jQuery("#rt-contact-message").val(),
        token: token,
    };
    jQuery.ajax({
        type: "POST",
        url: jQuery("form#rt-contact-form")[0].action,
        contentType: 'application/json', 
        data: JSON.stringify(formData),
        dataType: "json",
        encode: true,
        success : function(result) {
            show_succes_toast();
        },
        error: function(xhr, resp, text) {
            show_error_toast();
        }
    })
    })
});

const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

jQuery("#rt-newsletter-submit").on('click', function(event){
    event.preventDefault();
    grecaptcha.enterprise.ready(async () => {
    const token = await grecaptcha.enterprise.execute('6Ld_TTAqAAAAAM9Mpk6cGNQIYNT_N34IX_NaqL-v', {action: 'CONTACT'});    
    var formValue = objectifyForm(jQuery("#rt-newsletter-form").serializeArray());
    
    jQuery("#rt-newsletter-form")[0].classList.add("rt-invalid-form")
    document.getElementById("rt-newsletter-form").reportValidity();

    var msg = ""
    if(!formValue["email"]) {
        const emailMsg = "Adres Email jest wymagany.\n";
        msg += emailMsg;
        jQuery('#newsletter-invalid-email').text(emailMsg);
        jQuery('#newsletter-invalid-email').show();
    } else if (!validateEmail(formValue["email"])) {
        const emailMsg = "Adres Email jest niepoprawny. Upewnij się, że jest w formacie \"nazwa@domena.pl\".\n";
        msg += emailMsg;
        jQuery('#newsletter-invalid-email').text(emailMsg);
        jQuery('#newsletter-invalid-email').show();
    } else {
        jQuery('#newsletter-invalid-email').hide();
    }
    if(!formValue["accept-terms"]) {
        const termsMsg = "Akceptacja regulaminu jest wymagana.\n"
        msg += termsMsg;
        jQuery('#newsletter-invalid-terms').text(termsMsg);
        jQuery('#newsletter-invalid-terms').show();
    } else {
        jQuery('#newsletter-invalid-terms').hide();
    }

    if (msg != "") {
        alert(msg);
        return false
    }
            
    
    jQuery("#rt-newsletter-submit")[0].disabled = true;
    var formData = {
        email: jQuery("#rt-newsletter-email").val(),
        token: token,
    };
    jQuery.ajax({
        type: "POST",
        url: jQuery("form#rt-newsletter-form")[0].action,
        contentType: 'application/json', 
        data: JSON.stringify(formData),
        dataType: "json",
        encode: true,
        success : function(result) {
            show_newsletter_toast();
        },
        error: function(xhr, resp, text) {
            show_newsletter_error_toast();
        }
    })
    })
});

function objectifyForm(formArray) {
    //serialize data function
    var returnArray = {};
    for (var i = 0; i < formArray.length; i++){
        returnArray[formArray[i]['name']] = formArray[i]['value'];
    }
    return returnArray;
}


async function show_succes_toast() {
    jQuery('#rt-contact-succes').show();
    await new Promise(r => setTimeout(r, 5000));
    jQuery('#rt-contact-succes').hide();
}

async function show_error_toast() {
    jQuery('#rt-contact-error').show();
    await new Promise(r => setTimeout(r, 2000));
    jQuery('#rt-contact-error').hide();
}

async function show_newsletter_toast() {
    jQuery('#rt-newsletter-succes').show();
    await new Promise(r => setTimeout(r, 5000));
    jQuery('#rt-newsletter-succes').hide();
}

async function show_newsletter_error_toast() {
    jQuery('#rt-newsletter-error').show();
    await new Promise(r => setTimeout(r, 2000));
    jQuery('#rt-newsletter-error').hide();
}

jQuery(document)
    .ajaxSend(function (event, xhr, options) {
        if (options.type.toUpperCase() === "POST") {
            jQuery('#rt-spinner').show();
        }
    })
    .ajaxStop(function () {
        jQuery('#rt-spinner').hide();
    });
